import { get } from '@api/api-client';

export interface CountryResponse {
  id: string;
  code: string;
  name: string;
  locale: string;
}

/** Fetches all available countries. */
export function getCountries(): Promise<CountryResponse[]> {
  return get<CountryResponse[]>('/countries');
}
